module.exports = __webpack_public_path__ + "static/versicherungsmakler-141e4492aec2dd6d11425eab61cd441e.pdf";